import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
//#endregion
//#region components
import { ReloadEvent, ViewPanel } from "components/common";
import DocumentationLogCreateLink from "./createLink";
import DocumentationLogCreateFormContainer from "../../documentationLog/createFormContainer";
import DocumentationLogList from "../../documentationLog/list";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const DocumentationWidget: React.FC = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onCreateLogClick = (onSubmit: () => void) => {
    dispatch(displayDialog({ ...popper, onSubmit: onSubmit }));
  };

  const popper: DialogProps = {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NewMessage),
    titleIcon: IconDefinitionConstants.WCommentDots,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
        successMessage: TranslationKeys.SupportIssue.CreateSuccessMessage,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <DocumentationLogCreateFormContainer />,
    maxWidth: "sm",
  };

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <ViewPanel
          icon={IconDefinitionConstants.WCommentDots}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.DocumentationLog)}
          appearance="lg"
          gridSize="lg"
          topRightContent={
            <DocumentationLogCreateLink onDocumentationLogCreate={onCreateLogClick.bind(null, reload)} />
          }
        >
          <DocumentationLogList widgetView reloadKey={reloadKey} />
        </ViewPanel>
      )}
    />
  );
};

export default DocumentationWidget;
